import * as React from 'react'
import { Grid, DictionaryValue } from '../../components'
import './InterstitialPage.scss'

type Props = {
    eventLogo: string
    eventName: string
    brandLogo: string
    brandName: string
    countdownRemaining: number
    target: string
    partnerOneBanner: string
    partnerOneName: string
    partnerTwoBanner: string
    partnerTwoName: string
    redirectionNotice: string
}

class InterstitialPage extends React.Component<Props> {
    render() {
        const {
            eventLogo,
            eventName,
            brandLogo,
            brandName,
            countdownRemaining,
            target,
            partnerOneBanner,
            partnerOneName,
            partnerTwoBanner,
            partnerTwoName,
            redirectionNotice,
        } = this.props

        return (
            <div className='interstitial-page'>
                <Grid className='interstitial-page__grid'>
                    <img
                        src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAABnRSTlMA/
                        wD/AP83WBt9AAAADElEQVQI12P4//8/AAX+Av7czFnnAAAAAElFTkSuQmCC'
                        data-blink-src={eventLogo}
                        alt={eventName}
                        className='interstitial-page__event-logo'
                    />
                    <img
                        src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAABnRSTlMA/
                        wD/AP83WBt9AAAADElEQVQI12P4//8/AAX+Av7czFnnAAAAAElFTkSuQmCC'
                        data-blink-src={brandLogo}
                        alt={brandName}
                        className='interstitial-page__brand-logo'
                    />
                    <p className='interstitial-page__redirection-notice'>{redirectionNotice}</p>
                    <p className='interstitial-page__countdown'>{countdownRemaining}</p>
                    <p className='interstitial-page__failure-text'>
                        <DictionaryValue token='interstitial.didnt-work' />{' '}
                        <a href={target} className='interstitial-page__retry-link'>
                            <DictionaryValue token='interstitial.click-here' />
                        </a>
                    </p>
                    <div className='interstitial-page__partners'>
                        {partnerOneBanner && (
                            <img
                                src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAABnRSTlMA/
                                wD/AP83WBt9AAAADElEQVQI12P4//8/AAX+Av7czFnnAAAAAElFTkSuQmCC'
                                data-blink-src={partnerOneBanner}
                                alt={partnerOneName}
                                className='interstitial-page__partner'
                            />
                        )}
                        {partnerTwoBanner && (
                            <img
                                src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAABnRSTlMA/
                                wD/AP83WBt9AAAADElEQVQI12P4//8/AAX+Av7czFnnAAAAAElFTkSuQmCC'
                                data-blink-src={partnerTwoBanner}
                                alt={partnerTwoName}
                                className='interstitial-page__partner'
                            />
                        )}
                    </div>
                </Grid>
            </div>
        )
    }
}

export default InterstitialPage
